import { API_BASE_ROUTES } from 'models/shared/types/apiRoutes';
import { buildPathWithQueryParams } from 'models/shared/helpers/utils';
import { PaginatedDocuments } from 'models/shared/types/pagination';
import { axiosErrorHandler, get } from 'models/shared/helpers/axiosInstance';
import { Lead, LeadFilterDto } from '../interfaces/lead.interface';

export const findAllLeads = async (
	dto: LeadFilterDto,
): Promise<PaginatedDocuments<Lead>> => {
	try {
		const res = await get<PaginatedDocuments<Lead>>(
			buildPathWithQueryParams(API_BASE_ROUTES.leads, dto),
		);
		return res.data;
	} catch (err: any) {
		throw axiosErrorHandler(err);
	}
};

export const getLead = async (id: string): Promise<Lead> => {
	try {
		const res = await get<Lead>(`${API_BASE_ROUTES.leads}/${id}`);
		return res.data;
	} catch (err: any) {
		throw axiosErrorHandler(err);
	}
};
